export default {"src":"/_next/static/media/griddynamics.2e8fee9b.svg","height":32,"width":178,"blurWidth":0,"blurHeight":0};